const env = window.__KINDRED__ENV;

export default env;
